export function handlerError(err) {
  let error = false;
  let message = "Transacción no puede ser procesada";
  if (err.response) {
    // client received an error response (5xx, 4xx)
    error = err.response.status !== 200;
    message = err.response.statusText; //err.response.data.error.message;
  } else if (err.request) {
    // client never received a response, or request never left
    error = true;
  } else {
    // anything else
    error = true;
  }
  return {
    error,
    message,
  };
}
